import { useEffect, useState } from "react";
import bookingApi from "../../api/booking/booking";
import { useNavigate } from "react-router-dom";
import clientsApi from "../../api/client/client";
import { t } from "i18next";
import { ui } from "../../helpers/ui";

const InitTrainingsLogic = () => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const navigate = useNavigate();
  const [bookings, setBookings] = useState<any[]>([]);

  const [client, setClient] = useState<any>();

  const [location, setLocation] = useState<string>("Centar");

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const locations = ["Centar", "Radnička"];

  const loadClient = () => {
    clientsApi
      .getMe()
      .then((response) => {
        if (response.status === 200) {
          setClient(response.data);
        }
      })
      .catch((e) => {
        ui.alert(t(e.response?.data?.error?.message || "Greška"));
      });
  };

  useEffect(() => {
    loadClient();
  }, []);

  useEffect(() => {
    loadBookings();
  }, []);

  useEffect(() => {
    loadBookings();
  }, [location]);

  const loadBookings = () => {
    setIsLoading(true);
    bookingApi
      .getBookingsForClients(location)
      .then((response) => {
        if (response.status === 200) {
          const sortedData = response.data.sort(
            (a: any, b: any) =>
              new Date(a.date).getTime() - new Date(b.date).getTime(),
          );
          setBookings(sortedData);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        setIsLoading(false);
        ui.alert(t(e.response?.data?.error?.message || "Greška"));
      });
  };

  const onBook = (data: any) => {
    bookingApi
      .book(data, location)
      .then(() => {
        loadBookings();
        loadClient();
      })
      .catch((e) => {
        loadBookings();
        loadClient();
        ui.alert(t(e.response?.data?.error?.message || "Greška"));
      });
  };

  const onSettings = async () => {
    navigate("/settings");
  };

  const onHome = () => {
    navigate("/home-client");
  };

  const onCancel = (id: number) => {
    bookingApi
      .cancel({ id })
      .then(() => {
        loadBookings();
        loadClient();
      })
      .catch((e) => {
        ui.alert(t(e.response?.data?.error?.message || "Greška"));
      });
  };

  const onChangeLocation = (event: any) => {
    setBookings([]);
    setLocation(event.target.value);
    setSelectedDate(null);
  };

  return {
    selectedDate,
    client,
    bookings,
    location,
    locations,
    isLoading,
    setSelectedDate,
    onHome,
    onSettings,
    onBook,
    onCancel,
    onChangeLocation,
  };
};

export default InitTrainingsLogic;
